import { takeEvery, fork, put, all, call } from "redux-saga/effects"

import { ProfileTypes } from "./actionTypes"
import { getProfileSuccess, profileSuccess, profileError } from "./actions"

import {
  getProfile,
  updateProfile,
} from "../../../helpers/backend_helper"
import { getAuthUser, setAuthUser } from "../../../helpers/auth"

function* fetchProfile(): Generator<any, void, any> {
  try {
    const response: any = yield call(getProfile);
    yield put(getProfileSuccess(response));

    const existing = getAuthUser() || {};
    setAuthUser({
      ...existing,
      username: response?.name ?? existing.username,
      email: response?.email ?? existing.email,
      user_id: response?.id ?? existing.user_id,
      team_id: response?.team_id ?? existing.team_id,
    });
  } catch (error) {
    yield put(profileError(error))
  }
}

function* editProfile({ payload: { user } } : any): Generator<any, void, any> {
  try {
    const response: any = yield call(updateProfile, user);
    yield put(getProfileSuccess(response));
    yield put(profileSuccess("Profile updated successfully."));

    const existing = getAuthUser() || {};
    setAuthUser({
      ...existing,
      username: response?.name ?? existing.username,
      email: response?.email ?? existing.email,
      user_id: response?.id ?? existing.user_id,
      team_id: response?.team_id ?? existing.team_id,
    });
  } catch (error) {
    yield put(profileError(error))
  }
}
export function* watchProfile() {
  yield takeEvery(ProfileTypes.GET_PROFILE, fetchProfile)
  yield takeEvery(ProfileTypes.EDIT_PROFILE, editProfile)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
